<template>
    <div>
        <div id="hero-banner">
            <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
            <div class="overlay text-center">
                <h1 id="hero-text">About us</h1>
            </div>
        </div>

        <div>
            <img :src="bannerImage" class="company-banner">
            <div class="container pt-6 pb-8">
                <p class="font-weight-400">
                    HEplusUS Inc. is an innovative mobile marketing company that owns and operates Cutiefy Mobile App.
                    Cutiefy is the 1st of its kind mobile booking app in the Philippines that helps users to book and pay for salon,
                    spa or aesthetic services conveniently from their choice of available beauty establishments nearby.
                </p>
                <p class="font-weight-400">
                    HEplusUS Inc. aims to open doors to bring brilliant and innovative ideas like Cutiefy to life.
                    We connect with businesses and open them to better possibilities for growth through new and innovative channels, products
                    or business models that the company creates. Through market research and the study of consumer behavior, the company develops
                    innovative ideas that delivers products and services in a more streamlined (convenient & accessible) way, thus shaping positive
                    behaviors among consumers and businesses. As such, HEplusUS Inc. is a game changer and market shaper wherein business partners
                    experience new streams of income and growth.
                </p>
                <p class="font-weight-400">
                    HEplusUS Inc. enables its business partners and employees to thrive and succeed in their chosen field and be the best they could
                    be for God’s glory. We are working to make lives of all our stakeholders beautiful in His time.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { resource } from "@utils/network";
export default {
    name: "AboutUsPage",
    computed: {
        bannerStyle() {
            return `background-image:url('${ resource("images/about-us-header.jpg") }')`;
        }
    },
    data: () => ({
        bannerImage: resource('images/About-Us-Banner-FB.jpg'),
    })
}
</script>

<style scoped lang="css">
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
    }
    #hero-text {
        margin-top: 400px;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }
</style>